var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notifications-list"},_vm._l((_vm.displayNotifications),function(notification){return _c('NotificationsListItem',{key:notification.id,attrs:{"notification":notification}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }